// extracted by mini-css-extract-plugin
module.exports = {"bb-donation-widget":"bb-donation-widget__ghRtt","bb-donation-widget__title":"bb-donation-widget__title__PoeOb","bb-donation-widget__wrapper":"bb-donation-widget__wrapper__3RcSD"};